export const SET_CLIENT_MONITOR_CONFIG = 'SET_CLIENT_MONITOR_CONFIG'
export const SET_CLIENT_MONITOR_CONFIG_FORBIDDEN = 'SET_CLIENT_MONITOR_CONFIG_FORBIDDEN'
